import { render, staticRenderFns } from "./MbpReview.vue?vue&type=template&id=32cb01c8&scoped=true"
import script from "./MbpReview.vue?vue&type=script&lang=js"
export * from "./MbpReview.vue?vue&type=script&lang=js"
import style0 from "./MbpReview.vue?vue&type=style&index=0&id=32cb01c8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../mbp_crm-adminclient-golive1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32cb01c8",
  null
  
)

export default component.exports